<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Reports</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-radio-group data-test="reportTypeGroup">
            <ion-list-header color="secondary">
                Report Selection - Step 1 of 3
            </ion-list-header>

            <ion-item-divider color="tertiary">Summary Reports</ion-item-divider>
            @for (report of summaryReports; track $index) {
  <ion-item [disabled]=vb.disabled>
                <ion-label class="ion-text-wrap">
                    <span class="line1">{{report.title}}</span><br />
                    <span class="line2">{{report.description}}</span>
                </ion-label>
                <ion-radio data-test="reportRadio" (click)="onChooseReportClick(report)"></ion-radio>
            </ion-item>
}

            <ion-item-divider color="tertiary">Detail Reports</ion-item-divider>
            @for (report of detailReports; track $index) {
  <ion-item [disabled]=vb.disabled>
                <ion-label class="ion-text-wrap">
                    <span class="line1">{{report.title}}</span><br />
                    <span class="line2">{{report.description}}</span>
                </ion-label>
                <ion-radio data-test="reportRadio" (click)="onChooseReportClick(report)"></ion-radio>
            </ion-item>
}

            <ion-item-divider color="tertiary">Settings Reports</ion-item-divider>
            @for (report of settingsReports; track $index) {
  <ion-item [disabled]=vb.disabled>
                <ion-label class="ion-text-wrap">
                    <span class="line1">{{report.title}}</span><br />
                    <span class="line2">{{report.description}}</span>
                </ion-label>
                <ion-radio data-test="reportRadio" (click)="onChooseReportClick(report)"></ion-radio>
            </ion-item>
}
        </ion-radio-group>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button data-test="nextButton" [disabled]=vb.disabled title="Next" (click)="onNextClick()">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>